import { gql } from '@apollo/client';
import { AuthenticateUserType } from '../../../utils/idbFns';

export type AUTHENTICATE_USERType =
  | {
      authenticateUser: AuthenticateUserType;
    }
  | null
  | undefined;

export const AUTHENTICATE_USER = gql`
  mutation AuthenticateUser($email: String!, $password: String!) {
    authenticateUser: authenticateUser(data: { email: $email, password: $password }) {
      token
      user {
        id
        dataRole
        organisations {
          id
          isDefault
          role {
            name
          }
          registrationRole {
            name
          }
          dataRole
          organisation {
            id
            isFunder
            isInstitution
            isServiceProvider
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
        }
      }
    }
  }
`;
